export const getFormattedTime = (timeObj, intl) => {
  const dateModel = new Date();
  dateModel.setHours(timeObj.h);
  dateModel.setMinutes(timeObj.m);
  return intl.formatTime(dateModel);
};
